export const MARKET_CART_STORAGE_KEY = "market-cart";

const getStorage = (storage) => {
  if (storage) {
    return storage;
  }

  try {
    if (typeof window === "undefined") {
      return null;
    }

    return window.localStorage;
  } catch {
    return null;
  }
};

export const readCartItems = (
  storage = null,
  storageKey = MARKET_CART_STORAGE_KEY,
) => {
  try {
    const targetStorage = getStorage(storage);

    if (!targetStorage) {
      return [];
    }

    const rawValue = targetStorage.getItem(storageKey);

    if (!rawValue) {
      return [];
    }

    const parsedValue = JSON.parse(rawValue);

    return Array.isArray(parsedValue) ? parsedValue : [];
  } catch (error) {
    console.error("Failed to load cart from localStorage:", error);
    return [];
  }
};

export const writeCartItems = (
  items,
  storage = null,
  storageKey = MARKET_CART_STORAGE_KEY,
) => {
  try {
    const targetStorage = getStorage(storage);

    if (!targetStorage) {
      return false;
    }

    targetStorage.setItem(storageKey, JSON.stringify(items));
    return true;
  } catch (error) {
    console.error("Failed to save cart to localStorage:", error);
    return false;
  }
};
